const USER_LOGIN_SAVE = 'login_save';
const USER_TOKEN = 'access_token';
const USER_INFO = 'user_info';

export {
  USER_LOGIN_SAVE,
  USER_TOKEN,
  USER_INFO,
};
